/* ═══════════════════════════════════════════════════════
   src/content/domains/cards/index.ts
   Aggregates all domain card arrays into a single export.
   Blood and the Void Dread set are playtest content; dread-hf is the
   Hope & Fear version. Pages pick one with pickVersion().
   ═══════════════════════════════════════════════════════ */



import arcanaCards from './arcana';
import bladeCards from './blade';
import bloodCards from './blood';
import boneCards from './bone';
import codexCards from './codex';
import dreadCards from './dread';
import dreadHfCards from './dread-hf';
import graceCards from './grace';
import midnightCards from './midnight';
import sageCards from './sage';
import splendorCards from './splendor';
import valorCards from './valor';

import type { DomainCard } from './types';

export type { DomainCard };

const asVoid = (cards: DomainCard[]): DomainCard[] => cards.map((c) => ({ ...c, source: 'Void' }));

const domainCards: DomainCard[] = [
  ...arcanaCards,
  ...bladeCards,
  ...asVoid(bloodCards),
  ...boneCards,
  ...codexCards,
  ...asVoid(dreadCards),
  ...dreadHfCards,
  ...graceCards,
  ...midnightCards,
  ...sageCards,
  ...splendorCards,
  ...valorCards,
];

export default domainCards;
